export function useQuery(): URLSearchParams {
  const { location } = window
  return new URLSearchParams(location.search)
}
